/**
 * index.js — PEFEP Site — v3
 * ---------------------------------------------------------------
 * Hydratation standard.
 *
 * La v2 tentait une hydratation "selective" : elle comparait un
 * marqueur window.__PRERENDU__ a l'URL courante et, en cas de
 * difference, vidait le conteneur pour repartir de zero. En
 * production, ce mecanisme se declenchait a tort et remplacait la
 * page par l'accueil.
 *
 * React sait deja gerer seul le cas ou le HTML prerendu ne
 * correspond pas exactement : il corrige silencieusement. On lui
 * fait donc simplement confiance avec hydrateRoot, sans logique
 * conditionnelle par-dessus.
 */

import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const conteneur = document.getElementById('root');

const arbre = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Si le conteneur contient du HTML prerendu, on hydrate.
// Sinon (developpement local), on rend normalement.
if (conteneur.hasChildNodes()) {
  hydrateRoot(conteneur, arbre);
} else {
  createRoot(conteneur).render(arbre);
}

reportWebVitals();